import permissions from '@/constants/permissions'

const ChildCardPreviousEditions = () =>
  import('@/views/dashboard/previousEditions/ChildCardPreviousEditions.vue')
const DocumentPreviousEditions = () =>
  import('@/views/dashboard/previousEditions/DocumentPreviousEditions.vue')
const PreviousEditionDocumentForm = () =>
  import('@/components/document/PreviousEditionDocumentForm.vue')

export default [
  {
    path: '/poprzednie-edycje/karta-dziecka/:childEditionId',
    name: 'ChildCardPreviousEditions',
    component: ChildCardPreviousEditions,
    props: true,
    meta: {
      requireAuth: true,
      permission: permissions.pastEditionChildView
    }
  },
  {
    path: '/poprzednie-edycje/dokument/:childEditionId',
    component: DocumentPreviousEditions,
    children: [
      {
        path: 'poczatek-naszej-historii',
        name: 'PreviousBeginningOfOurStory',
        component: PreviousEditionDocumentForm,
        props: true,
        meta: {
          type: 'beginning_of_our_story',
          requireAuth: true,
          permission: permissions.pastEditionChildView
        }
      },
      {
        path: 'podsumowanie-naszej-historii',
        name: 'PreviousSummaryOfOurStory',
        component: PreviousEditionDocumentForm,
        props: true,
        meta: {
          type: 'summary_of_our_story',
          requireAuth: true,
          permission: permissions.pastEditionChildView
        }
      },
      {
        path: 'aplikacja-wolontariusza',
        name: 'PreviousVolunteerDescription',
        component: PreviousEditionDocumentForm,
        props: true,
        meta: {
          type: 'volunteer_description',
          requireAuth: true,
          permission: permissions.pastEditionChildView
        }
      },
      {
        path: 'ankieta-koordynatora',
        name: 'PreviousCoordinatorQuestionnaire',
        component: PreviousEditionDocumentForm,
        props: true,
        meta: {
          type: 'coordinator_questionnaire',
          requireAuth: true,
          permission: permissions.pastEditionChildView
        }
      },
      {
        path: 'zgoda-rodzica-opiekuna',
        name: 'PreviousGuardianConsent',
        component: PreviousEditionDocumentForm,
        props: true,
        meta: {
          type: 'guardian_consent',
          requireAuth: true,
          permission: permissions.pastEditionChildView
        }
      }
    ]
  }
]
